import { FlexPassSubscription } from "./FlexPassTypes";
import {
  MainSpecializations,
  SpecialistLevel,
  SpecialistTag,
} from "./TypeSpecialist";
import { TypeUserData } from "./TypeUsers";

export enum TreeQuizChoosedSpecialistType {
  COACH = "COACH",
  PSYCHOTHERAPIST = "PSYCHOTHERAPIST",
}

export enum PromocodeType {
  SELECTION = "selection",
  SUBSCRIBTION = "subscription",
}

export type DiscountPromocode = {
  _id: string;
  code: string;
  startDate: string;
  endDate: string;
  quantity: number;
  quantityPerUser: number;
  usedBy: TypeUserData[];
  discount: {
    amount?: number;
    percentage?: number;
  };
  type: PromocodeType;
  subscriptions?: FlexPassSubscription[];
  selectionCombinations?: {
    language: string;
    mainSpecialization: MainSpecializations;
    direction: TreeQuizChoosedSpecialistType;
    level: SpecialistLevel;
    topic: SpecialistTag;
  }[];
  onlyTalziExpense: boolean;
  description?: string;
};

export type NewDiscountPromocode = {
  code?: string;
  startDate: Date;
  endDate: Date;
  quantity: number;
  quantityPerUser: number;
  discount: {
    amount?: number;
    percentage?: number;
  };
  type: PromocodeType;
  subscriptions?: string[];
  selectionCombinations?: {
    language: string;
    mainSpecialization: string;
    direction: TreeQuizChoosedSpecialistType;
    level: string;
    topic: string;
  }[];
  onlyTalziExpense: boolean;
  description?: string;
};

export type PromocodesFilters = {
  language?: string[];
  mainSpecialization?: string[];
  level?: string[];
  startDate?: { from?: Date; to?: Date };
  endDate?: { from?: Date; to?: Date };
  type?: "selection" | "subscription";
  page: number;
  limit: number;
  isActive?: boolean;
};

export type PromocodesParamsAvailable = {
  totalAmount: number;
  languages: { value: string; choosable: boolean }[];
  mainSpecializations: {
    value: MainSpecializations;
    choosable: boolean;
  }[];
  levels: {
    value: SpecialistLevel;
    choosable: boolean;
  }[];
  types: { value: PromocodeType; choosable: boolean }[];
};
